import {
  GET_ARRIVALS_FAILED,
  GET_ARRIVALS_STARTED,
  GET_ARRIVALS_SUCCESS,
  POST_GUEST_FOR_CHAT_FAILED,
  POST_GUEST_FOR_CHAT_INITIATED,
  POST_GUEST_FOR_CHAT_STARTED,
  POST_GUEST_FOR_CHAT_SUCCESS
} from '../actions/actionTypes'

export default function reviews(
  state = {
    loading: true,
    errored: false,
    arrivals: [],
    postingGuest: false,
    postingFailed: false,
    lastPostedGuest: null,
    lastFailedGuest: null,
    error: null
  },
  action
) {
  switch (action.type) {
    case GET_ARRIVALS_STARTED:
      return {
        ...state,
        loading: true,
        arrivals: []
      }

    case GET_ARRIVALS_FAILED:
      return {
        ...state,
        loading: false,
        errored: false,
        error: null,
        arrivals: []
      }

    case GET_ARRIVALS_SUCCESS:
      return {
        ...state,
        loading: false,
        errored: false,
        error: null,
        arrivals: action.payload
      }

    case POST_GUEST_FOR_CHAT_STARTED:
      return {
        ...state,
        postingGuest: true,
        postingFailed: false,
        error: null
      }

    case POST_GUEST_FOR_CHAT_INITIATED:
      return {
        ...state,
        lastPostedGuest: action.payload
      }

    case POST_GUEST_FOR_CHAT_SUCCESS:
      return {
        ...state,
        postingGuest: false,
        postingFailed: false,
        error: null,
        lastPostedGuest: null
      }

    case POST_GUEST_FOR_CHAT_FAILED:
      return {
        ...state,
        postingGuest: false,
        postingFailed: true,
        error: action.payload
      }

    case 'TEST_GUEST_FOR_CHAT_SUCCESS':
      return {
        ...state,
        postingGuest: false,
        lastPostedGuest: {
          guestFirstName: 'Sinan',
          guestLastName: 'Aksay',
          roomNumber: '502',
          guestPhoneNumber: '6699006835',
          guestPhoneCountryCode: '1'
        }
      }

    default:
      return state
  }
}
